import type { PublicState } from '../../shared/protocol';

/** Portal status surfaces. The seeker gets a "trap in play" chip while it's
 *  armed (NO location), and a "reach the exit" prompt once transported. */
export function PortalBanner({ state }: { state: PublicState }) {
  const role = state.you.role;
  const p = state.portal;

  if (role === 'seeker') {
    if (p?.state === 'triggered') {
      return (
        <div className="curse-banner curse-banner--trap" data-testid="portal-banner">
          <div className="curse-banner__title">Transported</div>
          <div className="curse-banner__body">
            No cards until you reach the <span className="exit">green exit</span>
          </div>
        </div>
      );
    }
    if (state.portalArmed) {
      // v11 §2B: several traps may be hidden — the chip carries the COUNT only.
      const n = state.portalsArmed ?? 1;
      return (
        <div className="portal-chip" data-testid="portal-chip" data-count={n}>
          <span className="dot dot--signal" />
          Portal · {n > 1 ? `${n} traps are hidden` : 'a trap is hidden'}
        </div>
      );
    }
  }

  if (role === 'hider' && (state.portals?.length || p)) {
    const portals = state.portals ?? (p ? [p] : []);
    const armed = portals.filter((x) => x.state === 'armed').length;
    const sprung = portals.length - armed;
    return (
      <div className="portal-chip" data-testid="portal-chip-hider" data-count={portals.length}>
        <span className="dot dot--signal" />
        {sprung > 0 ? 'Portal sprung' : armed > 1 ? `${armed} portals armed` : 'Portal armed'}
      </div>
    );
  }
  return null;
}
